import Cookies from 'js-cookie'

export const isAppInstalled = () =>
	Cookies.get('appInstalled') ||
	window.matchMedia('(display-mode: standalone)').matches ||
	window.navigator.standalone

export const handleAppInstalled = (setIsInstallPromptVisible) => {
	Cookies.set('appInstalled', 'true', { expires: 365 })
	setIsInstallPromptVisible(false)
}

export const handleDismiss = (setIsInstallPromptVisible) => {
	Cookies.set('promptDismissed', 'true', { expires: 7 })
	setIsInstallPromptVisible(false)
}

export const handleBeforeInstallPrompt = (
	e,
	setDeferredPrompt,
	setIsInstallPromptVisible
) => {
	if (isAppInstalled()) {
		return
	}

	e.preventDefault()
	setDeferredPrompt(e)
	setIsInstallPromptVisible(true)
}
